export default "__VITE_ASSET__D9$W7Asn__"